export default __webpack_public_path__ + "static/media/EESymbolsImg3.cefefb6c.jpg";